import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {delay, finalize} from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JWTInterceptor implements HttpInterceptor{

    private readonly headers = new HttpHeaders({'Content-language':'en'});
    private authLocalStorageToken = `${environment.appVersion}-${environment.USERDATA_KEY}`;
    constructor() {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.getAuthFromLocalStorage();
        if(token) {
            const request = req.clone({
               setHeaders:{Authorization: `Bearer ${token}`}
            });
            return next.handle(request)
          }
          return next.handle(req)
    }

    private getAuthFromLocalStorage() {
        try {
          const authData = JSON.parse(
            localStorage.getItem(this.authLocalStorageToken)
          );
          return authData?.token
        } catch (error) {
          console.error(error);
          return undefined;
        }
      }

}
